export function getdata(){
	var obj = {
		
			headDataI:[
				{
					title: "减税性质代码及名称",
					prop: "zzs_6_x_0",
					width:"100px",
					custom:true,

				},
				{
					title: "栏次",
					prop: "grade",
					width:"60px",
					custom:true,
				},
				{
					title: "期初余额",
					prop: "zzs_6_x_1",
					width:"",align:'right',
					children:[
						{
						title: "1",align:'right',
						prop: "zzs_6_x_1",
						custom:true,
						width:"",
						},
					]
				},
				{
					title: "本期发生额",
					prop: "zzs_6_x_2",
					width:"",align:'right',
					children:[
						{
						title: "2",align:'right',
						prop: "zzs_6_x_2",
						custom:true,
						width:"",
						},
					]
				},
				{
					title: "本期应抵减税额",
					prop: "zzs_6_x_3",
					width:"",align:'right',
					children:[
						{
						title: "3=1+2",align:'right',
						prop: "zzs_6_x_3",
						custom:true,
						width:"",
						},
					]
				},
				{
					title: "本期实际抵减税额",
					prop: "zzs_6_x_4",
					width:"",align:'right',
					children:[
						{
						title: "4≤3",align:'right',
						prop: "zzs_6_x_4",
						custom:true,
						width:"",
						},
					]
				},
				{
					title: "期末余额",
					prop: "zzs_6_x_5",
					width:"",align:'right',
					children:[
						{
						title: "5=3-4",align:'right',
						prop: "zzs_6_x_5",
						custom:true,
						width:"",
						},
					]
				},
			],
			tableDataI:[
				{
					title:"合计",
					grade:"1",
					disabledzzs_6_x_1:true,
					disabledzzs_6_x_2:true,
					disabledzzs_6_x_3:true,
					disabledzzs_6_x_4:true,
					disabledzzs_6_x_5:true
				},
				{
					grade:"2",
					disabledzzs_6_x_1:true,
					disabledzzs_6_x_3:true,
					disabledzzs_6_x_5:true
				},
				{
					grade:"3",
					disabledzzs_6_x_1:true,
					disabledzzs_6_x_3:true,
					disabledzzs_6_x_5:true
				},
				{
					grade:"4",
					disabledzzs_6_x_1:true,
					disabledzzs_6_x_3:true,
					disabledzzs_6_x_5:true
				},
				{
					grade:"5",
					disabledzzs_6_x_1:true,
					disabledzzs_6_x_3:true,
					disabledzzs_6_x_5:true
				},
				{
					grade:"6",
					disabledzzs_6_x_1:true,
					disabledzzs_6_x_3:true,
					disabledzzs_6_x_5:true
				},
			],
			headDataII:[
				{
					title: "",
					prop: "zzs_6_x_0",
					width:"100px",
					custom:true,
				},
				{
					title: "栏次",
					prop: "grade",
					width:"60px",
					custom:true,
				},
				{
					title: "免征增值税项目销售额",
					prop: "",
					width:"",
					children:[
						{
						title: "1",
						prop: "zzs_6_x_1",align:'right',
						custom:true,
						width:"",
						},
					]
				},
				{
					title: "免税销售额扣除项目本期实际扣除金额",
					prop: "",
					width:"",
					children:[
						{
						title: "2",align:'right',
						prop: "zzs_6_x_2",
						custom:true,
						width:"",
						},
					]
				},
				{
					title: "扣除后免税销售额",
					prop: "",
					width:"",
					children:[
						{
						title: "3=1-2",align:'right',
						prop: "zzs_6_x_3",
						custom:true,
						width:"",
						},
					]
				},
				{
					title: "免税销售额对应的进项税额",
					prop: "",
					width:"",
					children:[
						{
						title: "4",align:'right',
						prop: "zzs_6_x_4",
						custom:true,
						width:"",
						},
					]
				},
				{
					title: "免税额",
					prop: "",
					width:"",
					children:[
						{
						title: "5",align:'right',
						prop: "zzs_6_x_5",
						custom:true,
						width:"",
						},
					]
				},
			],
			tableDataII:[
				{
					title:"合  计",
					grade:"7",
					disabledzzs_6_x_1:true,
					disabledzzs_6_x_2:true,
					disabledzzs_6_x_3:true,
					disabledzzs_6_x_4:true,
					disabledzzs_6_x_5:true
				},
				{
					title:"出口免税",
					grade:"8",
					disabledzzs_6_x_2:true,
					disabledzzs_6_x_3:true,
					disabledzzs_6_x_4:true,
					disabledzzs_6_x_5:true
				},
				{
					title:"其中：跨境服务",
					grade:"9",
					disabledzzs_6_x_2:true,
					disabledzzs_6_x_3:true,
					disabledzzs_6_x_4:true,
					disabledzzs_6_x_5:true
				},
				{
					title:"",
					grade:"10",
					disabledzzs_6_x_3:true,
					disabledzzs_6_x_4:true,
					disabledzzs_6_x_5:true
				},
				{
					title:"",
					grade:"11",
					disabledzzs_6_x_3:true,
					disabledzzs_6_x_4:true,
					disabledzzs_6_x_5:true
				},
				{
					title:"",
					grade:"12",
					disabledzzs_6_x_3:true,
					disabledzzs_6_x_4:true,
					disabledzzs_6_x_5:true
				},
				{
					title:"",
					grade:"13",
					disabledzzs_6_x_3:true,
					disabledzzs_6_x_4:true,
					disabledzzs_6_x_5:true
				},
				{
					title:"",
					grade:"14",
					disabledzzs_6_x_3:true,
					disabledzzs_6_x_4:true,
					disabledzzs_6_x_5:true
				},
				{
					title:"",
					grade:"15",
					disabledzzs_6_x_3:true,
					disabledzzs_6_x_4:true,
					disabledzzs_6_x_5:true
				},
				{
					title:"",
					grade:"16",
					disabledzzs_6_x_3:true,
					disabledzzs_6_x_4:true,
					disabledzzs_6_x_5:true
				}
			],
		
	}
	return obj
}
